import styled from 'styled-components';
import { Box, Paper as MUIPaper, Popper as MUIPopper } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import MUIButton from '@material-ui/core/Button';
import { colors } from '@material-ui/core';

export const Popper = styled(MUIPopper)`
  z-index: 9999;
  top: 10px !important;


`;

export const Header = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const Paper = styled(MUIPaper)`
  box-shadow: 0px 4px 4px rgba(32, 59, 92, 0.07),
    0px 7px 20px rgba(32, 59, 92, 0.1);
    top: 10px !important;
`;

export const Content = styled(Box)`
${({ theme: { breakpoints, colors } }) => `
  width: 300px;
  max-height: calc(100vh - 410px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0;
  outline: 1px solid ${colors.golds.gold1};
  overflow: hidden;
  overflow-y: auto;
  color: #fff;
  box-shadow: 0 5px 5px 0px ${colors.blacks.blacktrans};
  background-color: ${colors.greens.green0};
`}`

export const Title = styled(Typography)`
  ${({ theme: { palette } }) => `
    color: ${palette.text.primary};
    font-weight: 700;
     ::hover {background-color: red;}
  `}
`;

export const Button = styled(MUIButton)`
  margin: 20px auto 0  !important;
  width: 80%; 
`;

export const Filters = styled(Box)`
${({ theme: { breakpoints, colors } }) => `
// > .MuiGrid-root button.filDne {width:80% !important; border:2px solid red;}
> .MuiFormControl-root label {padding: 0 25px}
> .MuiFormControl-root label:hover {background-color: ${colors.greens.green3}}
> .MuiFormControl-root label span p { color:${colors.whites.white1} !important}
> .cfkaZp .Mui-checked svg {fill: white !important}
 .MuiGrid-container {max-width: 100% !important; flex-basis: 100% !important;
 .MuiFormControlLabel-label {background:transparent !important; border:1px solid transparent !important}

}

> .MuiFormControl-root .Mui-checked svg {fill: white !important}
> .MuiGrid-root .MuiFormControlLabel-root .Mui-disabled  {border: 0 !important }
 >  .MuiTypography-body2{ 
 color: ${colors.whites.white} !important 
 }
}
  width: 100%;
  padding: 0 0
p.MuiTypography-root {color: #fff !important}
  `}

`;
